/**
 * `customVariants.variant` values the Memo (`TransactionColumn.NOTE`) column
 * understands. `DEFAULT` and `REVIEW` edit through a popover; `INLINE`
 * renders an always-visible input instead.
 */
export const NoteCellVariant = {
    DEFAULT: "default",
    REVIEW: "review",
    INLINE: "inline",
} as const;
